<div class="line my-3">
  <h5 class="username my-1">{{ usernameString }}</h5>
  @if (!content) {
    <p-progressSpinner
      styleClass="w-2rem h-2rem"
      strokeWidth="5"
    />
  }
  @if (files && files.length > 0) {
    <div class="font-italic text-sm">
      <span i18n="@@chat_line_files_text">Fichiers:</span>&nbsp;
      @for (file of files; track file) {
        <span>{{ file.filename }}</span> &nbsp;
      }
    </div>
  }

  <markdown
    class="markdown my-1 line-height-3"
    [data]="content!.toString()"
    (ready)="onMarkdownReady()"
    #markdown
  />
  <div class="buttons my-1">
    @if (content) {
      <button
        class="mr-3"
        type="button"
        pTooltip="Copier le message"
        i18n-pTooltip="@@chat_line_copy_tooltip"
        tooltipPosition="bottom"
        (click)="copyHtmlOfElement(markdown.element.nativeElement)"
      >
        <i class="pi pi-copy"></i>
      </button>
      @if (!readonly) {
        <button
          type="button"
          pTooltip="Supprimer le message"
          i18n-pTooltip="@@chat_line_remove_message_tooltip"
          tooltipPosition="bottom"
          (click)="delete.emit()"
        >
          <i class="pi pi-trash"></i>
        </button>
      }
    }
  </div>
</div>
